import '../../../app.es6';
import angular from 'angular';

const COMPONENT_NAME = 'dialogDeleteVideo';
class DialogDeleteVideo {
  /* @ngInject */
  constructor ($rootScope, $scope, SharedState, commonApiFactory, commonFactory, Const) {
    this.Const = Const;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.UiSharedState = SharedState;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    DialogDeleteVideo.$inject = ['$rootScope', '$scope', 'SharedState', 'commonApiFactory', 'commonFactory', 'Const'];
  }

  deleteVideo () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    let pathParams = {
      videoId: this.$rootScope.videoId
    };
    return this.commonApiFactory.deleteVideosVideoId(pathParams)
      .then(() => {
        return this.commonApiFactory.deleteNotificationsVideosVideoId(pathParams);
      })
      .then((res) => {
        this.$rootScope.videoList.splice(this.$rootScope.fileIndex, 1);
        if (this.$rootScope.videoList.length === 0) {
          this.$rootScope.videoList.push({});
        }
        this.$rootScope.parentScope.$apply();
      })
      .catch((err) => {
        throw err;
      });
  }
}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME
    },
    controller: DialogDeleteVideo,
    templateUrl: 'app/components/dialog/delete-video/dialog-delete-video.template.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/dialog/delete-video/dialog-delete-video-controller.es6